import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]" data-testid="loading-screen">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-[#002FA7] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="font-mono-data text-xs tracking-widest uppercase text-[#A1A1AA]">Loading</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Block access to dashboard routes until email is verified.
  // Admin is exempt (seeded admin doesn't go through signup).
  if (user.role !== "admin" && user.email_verified === false) {
    return <Navigate to="/verify-email" replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  }

  return children;
}
